"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = configure;
Object.defineProperty(exports, "getConfig", {
  enumerable: true,
  get: function get() {
    return _utils.getConfig;
  }
});
Object.defineProperty(exports, "getCustomizable", {
  enumerable: true,
  get: function get() {
    return _utils.getCustomizable;
  }
});
Object.defineProperty(exports, "getPrefixCls", {
  enumerable: true,
  get: function get() {
    return _utils.getPrefixCls;
  }
});
Object.defineProperty(exports, "getProPrefixCls", {
  enumerable: true,
  get: function get() {
    return _utils.getProPrefixCls;
  }
});
Object.defineProperty(exports, "isCustomizable", {
  enumerable: true,
  get: function get() {
    return _utils.isCustomizable;
  }
});
var _dataset = require("choerodon-ui/dataset");
var _default = _interopRequireDefault(require("./default"));
var _utils = require("./utils");
(0, _dataset.overwriteConfigMergeProps)(['pagination']);
(0, _dataset.overwriteDefaultConfig)(_default["default"]);
function configure(config) {
  var merge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  (0, _dataset.configure)(config, merge ? undefined : null);
}